export const OVERVIEW_TABS = {
  CONSUMPTION: 'CONSUMPTION',
  INDEX: 'INDEX',
  FORECAST: 'FORECAST',
  SETTINGS: 'SETTINGS',
  DELEGATES: 'DELEGATES',
};
